import React from "react";
import ErrorPage from "./ErrorPage";

function Page404() {
  return <ErrorPage code="404" title="Oops! Not Found ;(" message="페이지를 찾을 수 없습니다." />;
}

export default Page404;
